import { MantineColor, MantineSpacing } from '@mantine/core';
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useAppContainerContext } from './AppContainerContext';

type RoutePaneProps = {
  bg?: MantineColor;
  p?: MantineSpacing;
  sidebarCollapsed?: boolean;
  skipDefaultSidebar?: boolean;
};

export function RoutePane({ bg, p, sidebarCollapsed, skipDefaultSidebar }: RoutePaneProps) {
  const {
    setContentPaneConfig,
    setSidebarCollapsed,
    setSkipDefaultSidebar,
    preventSidebarCollapse,
  } = useAppContainerContext();

  useEffect(() => {
    setContentPaneConfig({ bg, p });
    if (sidebarCollapsed !== undefined && !(sidebarCollapsed && preventSidebarCollapse)) {
      setSidebarCollapsed(sidebarCollapsed);
    }
    if (skipDefaultSidebar !== undefined) setSkipDefaultSidebar(skipDefaultSidebar);
    return () => {
      setContentPaneConfig({});
      if (!preventSidebarCollapse) setSidebarCollapsed(false);
      if (skipDefaultSidebar) setSkipDefaultSidebar(false);
    };
  }, [
    bg,
    p,
    sidebarCollapsed,
    skipDefaultSidebar,
    preventSidebarCollapse,
    setContentPaneConfig,
    setSidebarCollapsed,
    setSkipDefaultSidebar,
  ]);

  return <Outlet />;
}
